import React from 'react';
import '../assets/styles/history.css';

function History({ historyLog, showhistory, setShowHistory }) {



  return (showhistory) ? (
    <div className='historyTable-tictactoe'>
      <button onClick={() => setShowHistory(false)} className='closeBtn-tictactoe'>X</button>
      <div className='historyRowFirst'>
        <span className='span-tictactoe'>Date</span>
        <span className='span-tictactoe'>Players</span>
        <span className='span-tictactoe'>Winner</span>
      </div>
      {historyLog.map((line, i) => <div className='historyRow-tictactoe' key={i}>{line}</div>)}
    </div>
  ) : '';
}

export default History;